import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { clientContactPersonQueries } from "~/modules/client/api/clientContactPerson/clientContactPersonQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


export const useCompaniesContactPersonSelectOptions = (companyId: string): FormInputOption[] => {
	const { data: contactPersons } = useQuery(clientContactPersonQueries.byCompany(companyId));
	return useMemo(() => {
		if (contactPersons) {
			return contactPersons
				.sort(byObjectProperty("fullName"))
				.map((contactPerson) => {
					const nameWithClient = `${contactPerson.fullName} (${contactPerson.client.displayName})`;
					return createInputOptionData(nameWithClient, contactPerson.id);
				});
		}
		return [];
	}, [contactPersons]);
};

